export const paths = {
  index: '/',
  home: '/',
  announcements: {
    index: '/announcements',
    announcement: (announcementId: string) => `/announcements/${announcementId}`,
  },
  calendar: {
    index: '/calendar-events',
  },
  communities: {
    index: '/communities',
    community: '/communities/:communityId',
  },
  documents: {
    index: '/documents',
    folder: (folderId: string) => `/documents/d/${folderId}`,
    document: '/documents/:documentId',
  },
  users: {
    index: '/users',
    details: (userId: string) => `/users/${userId}`,
  },
  requests: {
    index: '/requests',
    request: (requestId: string) => `/requests/${requestId}`,
    attachments: (requestId: string) => `/requests/${requestId}/attachments`,
    quotes: (requestId: string) => `/requests/${requestId}/quotes`,
    conversations: (requestId: string) => `/requests/${requestId}/conversations`,
  },
  // requests: {
  //   index: '/requests',
  //   request: (requestId: string) => `/requests/${requestId}`,
  // },
  meetings: {
    index: '/meetings',
    meeting: '/meetings/:meetingId',
  },
  units: {
    index: '/units',
    unit: '/units/:unitId',
    details: (unitId: string) => `/units/${unitId}`,
  },
  reservations: {
    index: '/reservations',
    reservation: (reservationId: string) => `/reservations/${reservationId}`,
    my: '/reservations/my',
  },
  discussion: '/discussion',
  // forums: {
  //   index: '/forums',
  //   forum: (forumId: string) => `/forums/${forumId}`,
  // },
  auth: {
    signIn: '/sign-in',
    signUp: '/sign-up',
    resetPassword: '/reset-password',
    confirmPasswordReset: '/reset-password/confirm',
    changePassword: '/change-password',
  },
  setup: {
    account: '/setup/account',
    community: '/setup/community',
    welcome: '/setup/welcome',
  },
  invitation: {
    token: (token: string) => `/invitation/${token}`,
  },
  // v2: {
  //   requests: {
  //     index: '/v2/requests',
  //     request: (requestId: string) => `/v2/requests/${requestId}`,
  //     attachments: (requestId: string) => `/v2/requests/${requestId}/attachments`,
  //     quotes: (requestId: string) => `/v2/requests/${requestId}/quotes`,
  //     conversations: (requestId: string) => `/v2/requests/${requestId}/conversations`,
  //   },
  // },
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password/:token',
  settings: {
    profile: {
      account: '/settings/details',
      notifications: '/settings/notifications',
      security: '/settings/details/security',
    },
    community: {
      index: '/settings/community',
      import: '/settings/community/import',
      activity: '/settings/community/activity',
      members: {
        index: '/settings/community/members',
        member: (userId: string) => `/settings/community/members/${userId}`,
      },
      managers: {
        index: '/settings/community/managers',
        manager: (userId: string) => `/settings/community/managers/${userId}`,
      },
      amenities: {
        index: '/settings/community/amenities',
        amenity: (amenityId: string) => `/settings/community/amenities/${amenityId}`,
      },
      reservations: {
        index: '/settings/community/reservations',
      },
      preferences: '/settings/community/preferences',
    },
    account: {
      index: '/settings/account',
      administrators: {
        index: '/settings/account/administrators',
        administrator: (administratorId: string) => `/settings/account/administrators/${administratorId}`,
      },
      systemUsers: {
        index: '/settings/account/system-users',
        user: (userId: string) => `/settings/account/system-users/${userId}`,
      },
    },
  },
  notAuthorized: '/errors/not-authorized',
  notFound: '/errors/not-found',
  internalServerError: '/errors/internal-server-error',
};
